import CryptoJS from 'crypto-js'
import { AesUtil } from './AesUtil';
import { Platform } from 'react-native';
import { current_client_config } from '../config/Constant';


export const fetchEncodedToken = () => {

    let current_client_id = current_client_config;
    let platform = Platform.OS;

    let deviceID = new Date().getTime();
    let encodedData;


    try {

        let iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        let salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        let aesUtil = new AesUtil(128, 1000);

        let ciphertext = aesUtil.encrypt(
            salt,
            iv,
            "1234567891234567",
            `${current_client_id}&${platform}&${deviceID}`
        );
        console.log("ciphertext", ciphertext);

        let keyAndCipher = (iv + "::" + salt + "::" + ciphertext);
        encodedData = btoa(keyAndCipher);

    } catch (err) {
        console.log("error in encryption process", err);
    }

    return { encodedData, deviceID };
}